document.addEventListener('DOMContentLoaded', function() {
  var accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      var accordionItem = header.parentElement;
      var accordionContent = accordionItem.querySelector('.accordion-content');

      // Vérifie si la section est déjà ouverte
      if (accordionItem.classList.contains('active')) {
        // Fermer la section
        accordionItem.classList.remove('active');
        accordionContent.style.maxHeight = null;
      } else {
        // Ouvrir la section sélectionnée sans fermer les autres
        accordionItem.classList.add('active');
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
      }
    });
  });
});
